import * as z from "zod";

/** Kicks off the `startNetTerms` workflow; the result arrives via the status RPC. */
export const startNetTerms = {
  name: "startNetTerms" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    workflowId: z.string(),
    /** A cutover was already running for this team; nothing new was started. */
    alreadyRunning: z.boolean(),
  }),
};

export const NetTermsCutoverResult = z.object({
  alreadyOnTerms: z.boolean(),
  /** Wallet credit returned to the merchant's cards. */
  refunded: z.number(),
  /** Credit no past top-up could absorb, still sitting in the wallet. */
  refundRemainder: z.number(),
  invoice: z
    .object({ billId: z.string(), amount: z.string(), dueDate: z.string() })
    .nullable(),
  periodStart: z.string(),
  periodEnd: z.string(),
});

export const getNetTermsCutoverStatus = {
  name: "getNetTermsCutoverStatus" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    workflowId: z.string().nullable(),
    running: z.boolean(),
    failed: z.boolean(),
    result: NetTermsCutoverResult.nullable(),
  }),
};

/** Turns terms off; the next label rolls the merchant back to calendar billing. */
export const stopNetTerms = {
  name: "stopNetTerms" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({}),
};
